import React, { useEffect } from 'react';
import MiniAppEvents from 'src/helpers/miniapp-events';
import './modal.scss';

export default function Modal({
  modalStyle,
  show,
  cardStyle,
  header,
  headerStyle,
  body,
  bodyStyle,
  footer,
  footerStyle,
  backdropStyle,
  modalProps,
  modalWrapper,
  modalWrapperProps,
  onShow = () => {},
  ...restProps
}) {
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const ModalWrapper = modalWrapper;

  const modalContents = (
    <div className={`modal-card ${cardStyle ? cardStyle : ''}`}>
      <header className={`modal-card-head ${headerStyle ? headerStyle : ''}`}>
        {header && header()}
      </header>

      <section className={`modal-card-body ${bodyStyle ? bodyStyle : ''}`}>
        {body && body()}
      </section>

      <footer className={`modal-card-foot ${footerStyle ? footerStyle : ''}`}>
        {footer && footer()}
      </footer>
    </div>
  );

  useEffect(() => {
    if (show) {
      onShow();
    }
  }, [show]);

  return (
    <div
      className={`${modalStyle ? modalStyle : ''} modal ${show ? 'is-active' : ''}`}
      {...restProps}
    >
      <div className="Modal">
        <div
          className={`modal-box ${backdropStyle ? backdropStyle : ''} ${
            inMiniProgram ? 'in-mini-app' : ''
          }`}
        >
          <div {...modalProps}>
            {modalWrapper ? (
              <ModalWrapper {...modalWrapperProps}>{modalContents}</ModalWrapper>
            ) : (
              modalContents
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
